import React, { Component } from "react";
import { withStyles, Checkbox, FormControlLabel, Dialog, IconButton, Button, Icon, Tooltip, Grid, FormControl, Select, InputLabel, Menu, MenuItem, List, ListItem, ListItemText, DialogActions, Chip, TextField } from "@material-ui/core";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as actionCreators from '../../store/actions/index';
import { CreateFieldsDynamicLeadEdit } from './CreateFieldsDynamicLeadEdit'
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import moment from 'moment';


const TooltipNew = withStyles((theme) => ({
  tooltip: {
      fontSize: 14,
  },
}))(Tooltip);

class ProfileDetails extends Component {
  state = {
    opportunities_id: "",
    lastname: "",
    city: "",
    addressState: "",
    zipcode: "",
    country: "",
    countryListArray: [],
    companyCurrencyData: [],
    focusValue: false,
    fieldsList: [],
    fieldsObj: {},
    systemTagsList: [],
    isUpdate: true,
    isopportunitiesdetailUpdate: true,
    opportunityFieldData: [],
    usersListArray: [],
    fnameError: false,
    userSettings: "",
    isAnyValueChange: false,
    selectedPipelineId: "",
    pipelineListArray: [],
    stageArray: [],
    comp_options: [],
    comp_value: '',
    primarycontact_value: "",
    primarycontact_options: [],
    pipeline_id_createpopup: "",
    isPipelineLoaded: true,
    updatedfieldid: "",

    /* STRAT won/lost/abandoned */
    changeDate: true,
    contactTypeList: [],
    contactTypeObj: [],
    contactTypeObjCmp: [],
    loassReasonList: [],
    PiplinecardId: null,
    optionalNoteWon: "",
    optionalNoteLost: "",
    optionalNoteAbandoned: "",

    lossdropdownVal: "0",
    opportunityContactListArray: [],
    opportunityCompanyListArray: [],

    isOpenWonPopup: false,
    isOpenLostPopup: false,
    isOpenAbandonedPopup: false,

    fullScreenLostDialog: true,
    minimizeLostDialog: false,

    fullScreenWonDialog: true,
    minimizeWonDialog: false,

    fullScreenAbandonedDialog: true,
    minimizeAbandonedDialog: false,
    /* END won/lost/abandoned */
    isEditVisibility: false,
    teamvisible: true,
    oldteamvisible: true,
    hasActiveTeamPermission: false,
    userTeamDetails: {},
    teamVisibilityLabel: "",
    crudPermission: {
      isdelete: true,
      isedit: true,
    },
    teamList: [],
    selectedTeamList: [],
    selectedUserList: [{}],
    oldSlectedUserList: [],
    oldSelctedTeamList: [],
    userListForVisibility: [],
    teamUser: [],
  };



  /*START WON LOST POPUP COCE*/

  getListing = (val) => {
    this.props.getOpportunitiesFilterList(this.props.apolloClient.client, val);
  }

  callOpportunityList = () => {
    let val = {
      filterdata: [],
      list: {
        limit: 1,
        pageno: 1,
        searchtext: "",
        sorttype: "",
        type: "list",
        fieldId: this.state.updatedfieldid,
        columnname: "",
        islimited: false
      },
      piplineid: parseFloat(this.state.selectedPipelineId),
      filterid: 1
    }
    this.getListing(val)
    this.props.getPipelines(this.props.apolloClient.client);
  }

  handleChangeVals = (event, source) => {
    if (event.target.type === 'checkbox') {
      this.setState({ [event.target.name]: event.target.checked });
    } else {
      this.setState({ [event.target.name]: event.target.value });
    }
  };

  handleMouseUpStaticLane = (type) => {
    if (type === "won") {
      this.setState({
        isOpenWonPopup: true,
        opportunityContactListArray: [],
        opportunityCompanyListArray: [],
      });
      this.props.getOpportunitiesContactList(this.props.apolloClient.client, parseInt(this.state.opportunities_id));
      this.props.getOpportunitiesCompanyList(this.props.apolloClient.client, parseInt(this.state.opportunities_id));
    } else if (type === "lost") {
      this.setState({ isOpenLostPopup: true });
    } else if (type === "abandoned") {
      this.setState({ isOpenAbandonedPopup: true });
    }
    this.setState({ isOpenedPipline: false });
  }

  handleLostPopupClose = () => {
    this.setState({
      isOpenLostPopup: false,
      // PiplinecardId:null,
      changeDate: true,
      optionalNoteLost: "",
      lossdropdownVal: "0",
    })
  }
  handleSaveLossPopup = () => {
    var req = {
      changedate: this.state.changeDate,
      notes: this.state.optionalNoteLost,
      lossreasonid: parseInt(this.state.lossdropdownVal),
      opportunitiesid: parseInt(this.state.PiplinecardId),
      type: "lost",
    }
    this.props.opportunitiesLost(this.props.apolloClient.client, req);
    setTimeout(() => {
      this.callOpportunityList()
    }, 3000);

    this.handleLostPopupClose()
  }



  handleLostDialogMinimize = () => {
    this.setState(oldStateminimizeLostDialog => ({ minimizeLostDialog: !oldStateminimizeLostDialog.minimizeLostDialog }));
    this.setState({ fullScreenLostDialog: false })
  }

  handleLostDialogFull = () => {
    this.setState(oldStatefullScreenLostDialog => ({ fullScreenLostDialog: !oldStatefullScreenLostDialog.fullScreenLostDialog }));
    this.setState({ minimizeLostDialog: false })
  }

  handleWonPopupClose = () => {
    this.setState({
      isOpenWonPopup: false,
      // PiplinecardId:null,
      contactTypeObj: [],
      contactTypeObjCmp: [],
      changeDate: true,
      optionalNoteWon: "",
    })
  }
  handleSaveWonPopup = () => {
    var contactdata = []
    var promise = new Promise((resolve, reject) => {
      this.state.contactTypeObj.map((v, k) => {
        if (v.checked == true) {
          var obj = {}
          obj.type = "contact"
          obj.typeid = v.contacttype
          obj.id = v.id

          var nmKey = this.findWithAttr(this.state.contactTypeList, "id", v.contacttype)
          obj.typevalue = this.state.contactTypeList[nmKey].name

          contactdata.push(obj)
        }
      })
      this.state.contactTypeObjCmp.map((v, k) => {
        if (v.checked == true) {
          var obj = {}
          obj.type = "company"
          obj.typeid = v.contacttype
          obj.id = v.id

          var nmKey = this.findWithAttr(this.state.contactTypeList, "id", v.contacttype)
          obj.typevalue = this.state.contactTypeList[nmKey].name

          contactdata.push(obj)
        }
      })
      resolve(1)
    })
    promise.then(result => {
      var req = {
        notes: this.state.optionalNoteWon,
        changedate: this.state.changeDate,
        contactdata: contactdata,
        opportunitiesid: parseInt(this.state.PiplinecardId),
      }

      this.props.opportunitiesWin(this.props.apolloClient.client, req);
      setTimeout(() => {
        this.callOpportunityList()
      }, 3000);
      this.handleWonPopupClose()
    });
  }

  handleWonDialogMinimize = () => {
    this.setState(oldStateminimizeWonDialog => ({ minimizeWonDialog: !oldStateminimizeWonDialog.minimizeWonDialog }));
    this.setState({ fullScreenWonDialog: false })
  }

  handleWonDialogFull = () => {
    this.setState(oldStatefullScreenWonDialog => ({ fullScreenWonDialog: !oldStatefullScreenWonDialog.fullScreenWonDialog }));
    this.setState({ minimizeWonDialog: false })
  }

  handleAbandonedPopupClose = () => {
    this.setState({
      isOpenAbandonedPopup: false,
      // PiplinecardId:null,
      changeDate: true,
      optionalNoteAbandoned: "",
    })
  }
  handleSaveAbandonedPopup = () => {
    var req = {
      changedate: this.state.changeDate,
      notes: this.state.optionalNoteAbandoned,
      lossreasonid: 0,
      opportunitiesid: parseInt(this.state.PiplinecardId),
      type: "abandoned",
    }
    this.props.opportunitiesLost(this.props.apolloClient.client, req);
    setTimeout(() => {
      this.callOpportunityList()
    }, 3000);
    this.handleAbandonedPopupClose()
  }

  handleAbandonedDialogMinimize = () => {
    this.setState(oldStateminimizeAbandonedDialog => ({ minimizeAbandonedDialog: !oldStateminimizeAbandonedDialog.minimizeAbandonedDialog }));
    this.setState({ fullScreenAbandonedDialog: false })
  }

  handleAbandonedDialogFull = () => {
    this.setState(oldStatefullScreenAbandonedDialog => ({ fullScreenAbandonedDialog: !oldStatefullScreenAbandonedDialog.fullScreenAbandonedDialog }));
    this.setState({ minimizeAbandonedDialog: false })
  }

  /*END WON LOST POPUP COCE*/

  // componentWillMount() {
  componentWillUnmount() {
    this.props.settingReducer.pipelineListArray.is_loaded = true
  }
  componentDidMount() {
    
    ValidatorForm.addValidationRule('IsURLValid', (value) => {
      if (value && value.length && value.length > 0) {
        var specialChar = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm;
        if (!specialChar.test(value)) {
          return false;
        }
      }
      return true;
    });

    let val = { typeId: 4 }
    let userData = JSON.parse(localStorage.getItem('user_data_session'))
    let userid = { userid: userData.id }
    this.props.getUserSetting(this.props.apolloClient.client, userid);
    this.props.getCompanyRecList(this.props.apolloClient.client);
    this.props.getContactRecList(this.props.apolloClient.client);
    this.props.customFieldList(this.props.apolloClient.client, val);
    this.props.getUserList(this.props.apolloClient.client);
    this.props.getCountryList(this.props.apolloClient.client);
    this.props.getCompanyCurrency(this.props.apolloClient.client);
    this.props.getTagsList(this.props.apolloClient.client);
    this.props.getTeam(this.props.apolloClient.client);

    if (this.props.opportunities_id && (this.state.opportunities_id != this.props.opportunities_id)) {
      this.props.getOpportunitiesField(this.props.apolloClient.client, parseInt(this.props.opportunities_id));
      this.setState({
        opportunities_id: parseInt(this.props.opportunities_id),
        isUpdate: true,
      }, () => this.forceUpdate())
    }

    this.props.getLossReasonList(this.props.apolloClient.client);
    this.props.getContactType(this.props.apolloClient.client);
  }
  componentWillUnmount() {
    // emailLogEmail  
    this.props.opportunityReducer.opportunityFieldData = [];
    this.props.opportunityReducer.opportunityLogList = [];
    this.props.opportunityReducer.opportunityLogSidebarList = [];
  }
  AllMemberDisplay = () => {
    let teamVisibilityLabel = "";
    let userCount = 0;
    let teamCount = 0;
    let teamUser = [];
    let usersListArray = this.props.settingReducer.usersListArray.data ? this.props.settingReducer.usersListArray.data : []
    usersListArray.length > 0 && usersListArray.map((user) => {
      if (user.teamlist.length > 0) {
        let userdata = { userteam: [], id: "", username: "" }
        teamCount = teamCount < user.teamlist.length ? user.teamlist.length : teamCount;
        user.teamlist.map((u) => { userdata.userteam.push(u.team.teamname) })
        userdata.id = user.id;
        userdata.username = user.name;
        userCount = userCount + 1;
        teamUser.push(userdata)
      }
    })
    teamVisibilityLabel = userCount + " users from " + teamCount + " team ";
    this.setState({
      teamVisibilityLabel: teamVisibilityLabel,
      teamUser: teamUser
    }, () => this.forceUpdate())
  }
  selectedUserDetails = (mainuser) => {
    let teamVisibilityLabel = "";
    let teamUser = [];
    let userdata = { userteam: [], id: "", username: "" }
    mainuser.teamlist.map((u) => { userdata.userteam.push(u.team.teamname) })
    userdata.id = mainuser.id;
    userdata.username = mainuser.name;
    teamUser.push(userdata)
    teamVisibilityLabel = "1 users from " + mainuser.teamlist.length + " team ";
    this.setState({
      teamVisibilityLabel: teamVisibilityLabel,
      teamUser: teamUser
    }, () => this.forceUpdate())
  }
  themSelves = (selectedOwner) => {
    let teamVisibilityLabel = "";
    let userCount = 0;
    let teamCount = 0;
    let teamUser = [];
    let usersListArray = this.props.settingReducer.usersListArray.data ? this.props.settingReducer.usersListArray.data : []
    usersListArray.length > 0 && usersListArray.map((user) => {
      if (user.teamlist.length > 0) {
        if (user.teamlist[0].teammanager === true || (user.email === selectedOwner.email)) {
          let userdata = { userteam: [], id: "", username: "" }
          teamCount = teamCount < user.teamlist.length ? user.teamlist.length : teamCount;
          user.teamlist.map((u) => { userdata.userteam.push(u.team.teamname) })
          userdata.id = user.id;
          userdata.username = user.name;
          userCount = userCount + 1;
          teamUser.push(userdata)
        }
      }
    })
    teamVisibilityLabel = userCount + " users from " + teamCount + " team ";
    this.setState({
      teamVisibilityLabel: teamVisibilityLabel,
      teamUser: teamUser
    }, () => this.forceUpdate())
  }
  getUserPermission = () => {
    if (this.props.settingReducer.userPermissionDetails.data) {
      let data = this.props.settingReducer.userPermissionDetails.data.data;
      if (data.teampermissionstatus === true &&
        data.visibilityaccess.length > 0) {
        let oppdt = "";
        let crudPermission = "";

        if (this.state.pipeline_id_createpopup === "1") {
          oppdt = data.visibilityaccess.find(function (e) { return e.piplineid === 1 });
        } else if (this.state.pipeline_id_createpopup === "2") {
          oppdt = data.visibilityaccess.find(function (e) { return e.piplineid === 2 });
        }
        if (this.props.authReducer.userRole.id === 3) {
          crudPermission = oppdt
        }
        if (oppdt.isaccess) {
          if (oppdt.viewoption === 1) {
            this.AllMemberDisplay();
          }
          if (oppdt.viewoption === 2 || oppdt.viewoption === 3) {
            var selectedOwner = this.state.fieldsObj["owner"]
            if (selectedOwner && selectedOwner.values) {
              if (selectedOwner.values.teamlist.length > 0) {//if member in any team 
                if (selectedOwner.values.teamlist[0].teammanager === false) {//owner is not  teammanager
                  if (oppdt.viewoption === 2) {
                    this.AllMemberDisplay();
                  } else {
                    this.themSelves(selectedOwner.values);
                  }
                } else {//owner is teammanager   
                  this.selectedUserDetails(selectedOwner.values);
                }
              } else { // not in any team 
                this.setState({ teamVisibilityLabel: "0 users", teamUser: [] }, () => this.forceUpdate())
              }
            } else {
              this.setState({ teamVisibilityLabel: "0 users", teamUser: [] }, () => this.forceUpdate())
            }
          }
        } else {//oppdt.isaccess === false
          this.setState({ teamVisibilityLabel: "0 users", teamUser: [] }, () => this.forceUpdate())
        }
        this.setState({
          crudPermission: crudPermission === "" ? this.state.crudPermission : crudPermission,
          hasActiveTeamPermission: true,
          viewoption: oppdt.viewoption,
        })
      } else {
        this.setState({ teamvisible: false })
      }
    }
  }

  componentWillReceiveProps(props) {
    this.getUserPermission();
    if (props.settingReducer.teamList.data && this.state.teamList !== props.settingReducer.teamList.data) {
      const teamList = props.settingReducer.teamList.data;
      let data = [];
      teamList.map((v, i) => {
        data.push({ id: v.id, teamname: v.teamname })
      });
      this.setState({ teamList: data })
    }
    if (props.settingReducer.generatedmailboxid.data) {
      let mailboxid = props.settingReducer.generatedmailboxid.data.mailboxid;
      this.setState({ mailboxid });
    }
    if (props.settingReducer.companyRecList && props.settingReducer.companyRecList.data && props.settingReducer.companyRecList.data.data) {
      let companyOptions = [];
      props.settingReducer.companyRecList.data.data.map((compOpt) => {
        companyOptions.push({ label: compOpt.name, value: compOpt.company_id });
      })
      this.setState({ comp_options: companyOptions });
    }
    if (props.settingReducer.loassReasonList.data != null) {
      var dataList = props.settingReducer.loassReasonList.data;
      this.setState({ loassReasonList: dataList });
    }
    if (props.settingReducer.contactRecList && props.settingReducer.contactRecList.data && props.settingReducer.contactRecList.data.data) {
      let contactOptions = [];
      props.settingReducer.contactRecList.data.data.map((conOpt) => {
        // contactOptions.push({ label: conOpt.name, value: conOpt.opportunities_id});
        contactOptions.push({ label: conOpt.name, value: conOpt.contact_id });
      })
      this.setState({ primarycontact_options: contactOptions });
    }
    //Pipelines list array
    if (props.settingReducer.pipelineListArray.data && this.state.isPipelineLoaded) {
      props.settingReducer.pipelineListArray.is_loaded = false
      var pipeData = props.settingReducer.pipelineListArray.data
      //Apply pipeline id to localstorage
      var selectedPipelineId = localStorage.getItem('selected_pipeline_id');
      if (!selectedPipelineId) {
        localStorage.setItem('selected_pipeline_id', "1");
      } else {
        selectedPipelineId = localStorage.getItem('selected_pipeline_id');
      }
      selectedPipelineId = localStorage.getItem('selected_pipeline_id');
      selectedPipelineId = selectedPipelineId.toString()
      var ky = this.findWithAttr(pipeData, 'id', selectedPipelineId);
      var pipelineArray = pipeData[ky];
      let allData = pipeData;
      if (props.settingReducer.userPermissionDetails.data) {
        let udata = props.settingReducer.userPermissionDetails.data.data
        if (udata.visibilityaccess.length > 0 &&
          udata.teampermissionstatus === true &&
          props.authReducer.userRole.id === 3) {
          allData = [];
          pipeData.map((val, k) => {
            let dt = udata.visibilityaccess.find(function (e) { return e.piplineid === parseInt(val.id) });
            if (dt && dt.isaccess) {
              localStorage.setItem('selected_pipeline_id', val.id);
              this.setState({ selectedPipelineId: val.id })
              allData.push(val)
            }
          })
        }
      }
      console.log("fdd", allData)
      this.setState({
        stageArray: pipelineArray.stage,
        fieldsObj: {
          ...this.state.fieldsObj,
          ["pipeline"]: { fieldid: "41", values: pipelineArray },
          ["stage"]: { fieldid: "47", values: pipelineArray.stage[0] },
          ["winpercentage"]: { fieldid: "52", opportunitiesvalue: pipelineArray.stage[0].probability },
        },
        pipelineListArray: allData,
        selectedPipelineId: selectedPipelineId,
        //pipeline_id_createpopup: selectedPipelineId,
      }, () => {
        this.forceUpdate()
        if (!this.state.pipeline_id_createpopup) {
          this.setState({
            pipeline_id_createpopup: selectedPipelineId,
            isPipelineLoaded: false,
          })
        }
      })
    }
    //storing user setting data in state
    if (props.settingReducer.userSettingArray.data && this.state.userSettings == "") {
      const settingData = props.settingReducer.userSettingArray.data;
      this.setState({
        userSettings: settingData,
      })
    }

    if (props.opportunityReducer.opportunityFieldData.error == true && props.opportunityReducer.opportunityFieldData.notify_msg.indexOf('Permission:') != -1) {
      this.props.history.push('/unauthorized');
    } else {
      if (props.opportunities_id && (this.state.opportunities_id != props.opportunities_id) || this.state.isUpdate && props.opportunities_id != undefined) {
        props.getOpportunitiesField(props.apolloClient.client, parseInt(props.opportunities_id));

        let logParams = { opportunitiesid: parseFloat(props.opportunities_id), activitypeid: [], logtypeid: [] }
        this.props.getOpportunitiesLogListNew(this.props.apolloClient.client, logParams);

        // if(props.opportunityReducer.opportunityFieldData.data )
        // {
        //   var emailkey1 = this.findWithAttr(props.opportunityReducer.opportunityFieldData.data, 'fieldkey', "email");
        //   if (emailkey1 != -1)
        //   {
        //     let emailData = props.opportunityReducer.opportunityFieldData.data[emailkey1];
        //     if (emailData.opportunitiesdetail[0] && emailData.opportunitiesdetail[0].values && emailData.opportunitiesdetail[0].values.length > 0)
        //     {
        //       localStorage.setItem('emailLogEmail', emailData.opportunitiesdetail[0].values[0].value);
        //       let logParams = { opportunitiesid: parseFloat(props.opportunities_id), emailid: emailData.opportunitiesdetail[0].values[0].value }
        //       //this.props.getOpportunitiesLogListNew(this.props.apolloClient.client, logParams);
        //     }
        //     else {
        //       localStorage.removeItem('emailLogEmail');
        //     }
        //   }
        // }

        this.setState({
          opportunities_id: parseInt(props.opportunities_id),
          PiplinecardId: parseInt(props.opportunities_id)
        }, () => this.forceUpdate())
      }
    }


    if (props.contactReducer.contactTypeList.data && props.contactReducer.contactTypeList.is_loaded) {
      props.contactReducer.contactTypeList.is_loaded = false
      this.setState({
        contactTypeList: props.contactReducer.contactTypeList.data,
      }, () => this.forceUpdate());
    }


    if (props.settingReducer.opportunitiesCustomFieldList.data && this.state.fieldsList.length == 0) {
      const customFields = props.settingReducer.opportunitiesCustomFieldList.data;
      this.setState({ fieldsList: customFields })
      var statuskey = this.findWithAttr(customFields, 'id', "45");
      var prioritykey = this.findWithAttr(customFields, 'id', "51");
      var defaultKeyStatus = this.findWithAttr(customFields[statuskey].options, 'id', 4);

      var vkey = this.findWithAttr(customFields, "id", "54");
      var visibilitydefault = this.findWithAttr(customFields[vkey].options, "is_default", true);


      this.setState({
        fieldsObj: {
          ...this.state.fieldsObj,
          ["visibility"]: { fieldid: "54", values: customFields[vkey].options[visibilitydefault], },
          ["status"]: { fieldid: "45", values: customFields[statuskey].options[defaultKeyStatus] },
          ["priority"]: { fieldid: "51", values: customFields[prioritykey].options[0] },
          ["created"]: { fieldid: "49", values: this.state.selectedDate },
        }
      })
    }

    if (props.settingReducer.countryListGql.data && this.state.countryListArray.length == 0) {
      const countryies = props.settingReducer.countryListGql.data;
      this.setState({ countryListArray: countryies })
    }
    if (props.settingReducer.usersListArray.data && this.state.usersListArray.length == 0) {
      const usersListArray = props.settingReducer.usersListArray.data;
      let userListForVisibility = [];
      usersListArray.map((data, i) => {
        userListForVisibility.push({ id: data.id, name: data.name })
      })
      this.setState({ usersListArray: usersListArray, userListForVisibility: userListForVisibility })
      var companyOwnerKey = this.findWithAttr(usersListArray, 'companyowner', "true");
      // this.setState({
      //   fieldsObj: {
      //     ...this.state.fieldsObj,
      //     ["owner"]: { fieldid: "4", values:usersListArray[companyOwnerKey]}
      //   }
      // })
    }

    if (props.opportunityReducer.opportunityContactList.data && props.opportunityReducer.opportunityContactList.is_loaded) {
      props.opportunityReducer.opportunityContactList.is_loaded = false
      var cData = props.opportunityReducer.opportunityContactList.data
      this.setState({
        opportunityContactListArray: cData,
      }, () => this.forceUpdate());

      var arra = []
      var promise = new Promise((resolve, reject) => {
        cData.map((v, k) => {
          var obj = {}
          obj.checked = true
          obj.contacttype = "2"
          obj.id = v.contact.id
          obj.type = "contact"
          arra.push(obj)
        })
        resolve(1)
      })
      promise.then(result => {
        this.setState({
          contactTypeObj: arra,
        }, () => this.forceUpdate());
      });

    }
    if (props.opportunityReducer.opportunityCompanyList.data && props.opportunityReducer.opportunityCompanyList.is_loaded) {
      props.opportunityReducer.opportunityCompanyList.is_loaded = false
      var cmpData = props.opportunityReducer.opportunityCompanyList.data
      var arra = []
      var promise = new Promise((resolve, reject) => {
        cmpData.map((v, k) => {
          var obj = {}
          obj.checked = true
          obj.contacttype = "2"
          obj.id = v.company.id
          obj.type = "company"
          arra.push(obj)
        })
        resolve(1)
      })
      promise.then(result => {
        this.setState({
          contactTypeObjCmp: arra,
        }, () => this.forceUpdate());
      });
      this.setState({
        opportunityCompanyListArray: cmpData,
      }, () => this.forceUpdate());
    }

    if (props.settingReducer.systemTagsList.data && this.state.systemTagsList.length == 0) {
      const tagsData = props.settingReducer.systemTagsList.data;
      this.setState({ systemTagsList: tagsData })
    }

    if (props.settingReducer.companyCurrencyData.data != null && this.state.companyCurrencyData.length == 0) {
      var cData = props.settingReducer.companyCurrencyData.data;
      this.setState({ companyCurrencyData: cData[0] });
    }

    if (props.opportunityReducer.opportunityFieldData.data && props.opportunityReducer.opportunityFieldData.is_loaded) {
      let opportunityFieldData = props.opportunityReducer.opportunityFieldData.data
      this.setState({
        fieldsObj: {},
        comp_value: '',
        primarycontact_value: "",
      }, () => {
        var key1 = this.findWithAttr(opportunityFieldData, 'id', "40");
        if (key1 !== -1) {
          this.setState({
            oldteamvisible: opportunityFieldData[key1].opportunitiesdetail[0].opportunities.teamvisible !== null && opportunityFieldData[key1].opportunitiesdetail[0].opportunities.teamvisible,
            teamvisible: opportunityFieldData[key1].opportunitiesdetail[0].opportunities.teamvisible !== null && opportunityFieldData[key1].opportunitiesdetail[0].opportunities.teamvisible,
          })
        }
        let fieldsObj = this.state.fieldsObj;
        this.setState({ opportunityFieldData: opportunityFieldData })
        let country = "";
        let selectedTeamList = [];
        let selectedUserList = [];
        const opportunityDataForEdit = props.opportunityReducer.opportunityFieldData.data;
        var tempStages = []
        var promise = new Promise((resolve, reject) => {
          opportunityDataForEdit.map((v, i) => {
            if (v.id == '44' || v.id == '42') {
              if (v.opportunitiesdetail.length > 0 && v.opportunitiesdetail[0].values.length > 0) {
                var optId = parseInt(v.opportunitiesdetail[0].values[0].id);
                if (v.id == '42') {//primary contact
                  this.setState({ primarycontact_value: optId });
                } else if (v.id == '44') {//company
                  this.setState({ comp_value: optId });
                }
              }
            } else if (v.fieldtype.id == '1' && v.id == '40') {//for first/last name          
              if (v.opportunitiesdetail.length > 0) {
                var data = {
                  fieldid: v.id,
                  opportunitiesvalue: v.opportunitiesdetail[0].fieldvalue
                }
                fieldsObj = {
                  ...fieldsObj,
                  [v.fieldkey]: data,
                }
              }
            }
            else if (v.fieldtype.id == '1' && v.id == '46') {//for owner field        
              if (v.opportunitiesdetail.length > 0 && v.opportunitiesdetail[0].values.length && v.opportunitiesdetail[0].values[0].id) {
                var companyOwnerKey = this.findWithAttr(this.state.usersListArray, 'id', v.opportunitiesdetail[0].values[0].id);
                if (companyOwnerKey !== -1) {
                  var ownerData = {
                    fieldid: v.id,
                    values: this.state.usersListArray[companyOwnerKey]
                  }
                  fieldsObj = {
                    ...fieldsObj,
                    [v.fieldkey]: ownerData,
                  }
                }
              }
            } else if (v.fieldtype.id == '1' && v.fieldkey == 'tags') {//for tag input
              var tagArray = []
              if (v.opportunitiesdetail.length > 0 && v.opportunitiesdetail[0].values.length > 0) {
                v.opportunitiesdetail[0].values.map((v, i) => {
                  tagArray.push(v.value);
                })
              }
              var data = {
                fieldid: v.id,
                values: tagArray
              }
              fieldsObj = {
                ...fieldsObj,
                [v.fieldkey]: data,
              }
            } else if (v.fieldtype.id == '1' && v.id == '50') {//For value with currency Field
              if (v.opportunitiesdetail.length > 0 && v.opportunitiesdetail[0].values.length > 0) {
                var data = {
                  fieldid: v.id,
                  opportunitiesvalue: v.opportunitiesdetail[0].values[0].value
                }
                fieldsObj = {
                  ...fieldsObj,
                  [v.fieldkey]: data,
                }
              }
            } else if ((v.fieldtype.id == '1' && v.id != '56' && v.id != '46' && v.id != '44' && v.id != '42') || v.fieldtype.id == '6' || v.fieldtype.id == '10' || v.fieldtype.id == '7' || v.fieldtype.id == '9') {//other textfield and number input
              if (v.opportunitiesdetail.length > 0 && v.opportunitiesdetail.length > 0) {
                var data = {
                  fieldid: v.id,
                  opportunitiesvalue: v.opportunitiesdetail[0].fieldvalue
                }
                fieldsObj = {
                  ...fieldsObj,
                  [v.fieldkey]: data,
                }
              }
            }

            if (v.fieldtype.id == '2') {//TextArea
              if (v.opportunitiesdetail.length > 0) {
                var data = {
                  fieldid: v.id,
                  opportunitiesvalue: v.opportunitiesdetail[0].fieldvalue
                }
                fieldsObj = {
                  ...fieldsObj,
                  [v.fieldkey]: data,
                }
              }
            }

            if (v.fieldtype.id == "3") {//checkboxes
              if (v.opportunitiesdetail.length > 0) {
                var data = {
                  fieldid: v.id,
                  opportunitiesvalue: v.opportunitiesdetail[0].fieldvalue
                }
                fieldsObj = {
                  ...fieldsObj,
                  [v.fieldkey]: data,
                }
              }
            }
            //if(this.state.fieldsList && this.state.fieldsList.length >0){
            if (v.fieldtype.id === '4') {//dropdown
              if (v.fieldid === "54" || v.fieldid === "45" || v.fieldid === "51") {//54-visibility,48-source,45-status,51-Priority
                if (v.opportunitiesdetail.length > 0 && v.opportunitiesdetail[0].values.length > 0) {
                  var optId = this.findWithAttr(v.options, 'id', v.opportunitiesdetail[0].values[0].id);
                  if (v.id === "54") {
                    if (v.opportunitiesdetail[0].values[0].id === 2) {
                      let filteredselectedTeamList = this.state.selectedTeamList.length > 0 ? this.state.selectedTeamList.filter(el => Object.keys(el).length) : []
                      if (v.opportunitiesdetail[0].values[0].visiblelist && filteredselectedTeamList !== v.opportunitiesdetail[0].values[0].visiblelist) {
                        selectedTeamList = v.opportunitiesdetail[0].values[0].visiblelist
                      }
                    } else if (v.opportunitiesdetail[0].values[0].id === 3) {
                      let filteredselectedUserList = this.state.selectedUserList.length > 0 ? this.state.selectedUserList.filter(el => Object.keys(el).length) : []
                      if (v.opportunitiesdetail[0].values[0].visiblelist && filteredselectedUserList !== v.opportunitiesdetail[0].values[0].visiblelist) {
                        selectedUserList = v.opportunitiesdetail[0].values[0].visiblelist
                      }
                    }
                  }
                  fieldsObj = {
                    ...fieldsObj,
                    [v.fieldkey]: { fieldid: v.id, values: v.options[optId] },
                  }
                }
              } else if (v.id === "41") {//pipeline
                if (v.opportunitiesdetail.length > 0 && v.opportunitiesdetail[0].values.length > 0) {
                  var optId = this.findWithAttr(v.options, 'id', parseInt(v.opportunitiesdetail[0].values[0].id));
                  fieldsObj = {
                    ...fieldsObj,
                    [v.fieldkey]: { fieldid: v.id, values: v.options[optId] },
                  }
                  tempStages = v.options[optId].stage
                  this.setState({
                    stageArray: v.options[optId].stage
                  }, () => {
                  })
                }
              } else if (v.id === "47") {//stage
                if (v.opportunitiesdetail.length > 0 && v.opportunitiesdetail[0].values.length > 0) {
                  var optId = this.findWithAttr(tempStages, 'id', parseInt(v.opportunitiesdetail[0].values[0].id));
                  fieldsObj = {
                    ...fieldsObj,
                    [v.fieldkey]: { fieldid: v.id, values: tempStages[optId] },
                  }
                }
              } else {
                if (v.opportunitiesdetail.length > 0 && v.opportunitiesdetail[0].values.length > 0) {
                  var optId = this.findWithAttr(v.options, 'id', parseInt(v.opportunitiesdetail[0].values[0].id));
                  fieldsObj = {
                    ...fieldsObj,
                    [v.fieldkey]: { fieldid: v.id, values: v.options[optId] },
                  }
                }
              }
            }
            if (v.fieldtype.id === '5') {//multi dropdown
              if (v.opportunitiesdetail.length > 0 && v.opportunitiesdetail[0].values.length > 0) {
                fieldsObj = {
                  ...fieldsObj,
                  [v.fieldkey]: { fieldid: v.id, values: v.opportunitiesdetail[0].values },
                }
              }
            }
            if (v.fieldtype.id === '8') {
              if (v.opportunitiesdetail.length > 0 && v.opportunitiesdetail[0].fieldvalue != "") {
                //var dt = moment.unix(v.opportunitiesdetail[0].fieldvalue).format(this.state.userSettings.dateformat).toString()
                var dt = new Date(moment(v.opportunitiesdetail[0].fieldvalue).format('YYYY-MM-DD'))
                dt = new Date(dt)
                fieldsObj = {
                  ...fieldsObj,
                  [v.fieldkey]: { fieldid: v.id, values: dt },
                }
              } else if (v.opportunitiesdetail.length > 0 && v.opportunitiesdetail[0].fieldvalue == "") {
                fieldsObj = {
                  ...fieldsObj,
                  [v.fieldkey]: { fieldid: v.id, values: null },
                }
              }
            }
          })

          this.setState({
            oldSelctedTeamList: [...selectedTeamList, {}],
            oldSlectedUserList: [...selectedUserList, {}],
            selectedTeamList: [...selectedTeamList, {}],
            selectedUserList: [...selectedUserList, {}],
            fieldsObj,
            country,
            isUpdate: false,
            isAnyValueChange: false
          }, () => {
            resolve(true)
          })
        });

        promise.then(result => {
          props.opportunityReducer.opportunityFieldData.is_loaded = false;
          this.setState({
            isAnyValueChange: false
          }, () => {
          })
        });
      })
    }
  }

  addNewField = (key, option) => {
    let data = this.state.fieldsObj[key];
    data.values.push({
      srno: (data.values.length + 1).toString(),
      id: option.id,
      value: ""
    })

    this.setState({
      fieldsObj: {
        ...this.state.fieldsObj,
        [key]: data
      }
    })
  }

  handleAddMoreField = (name, key, index, value) => {
    let data = this.state.fieldsObj[key];
    data.values[index][name] = value;
    var keyName = key;
    var keyVal = data;
    this.setState({
      fieldsObj: {
        ...this.state.fieldsObj,
        [key]: data
      },
      isAnyValueChange: true
    }, () => {
      // setTimeout(() => {
      //   //dont upadte lead if first name is empty
      //   if(this.state.fieldsObj['name'] && this.state.fieldsObj['name'].opportunitiesvalue == ""){
      //     return false
      //   }
      //   //dont allow to update if value length 1 and value is blank
      //   if(keyVal.values.length == 1 && keyVal.values[0].value == ""){
      //     return false
      //   }
      //   if (this.state.fieldsObj[keyName] == keyVal) {
      //     this.handleFormSubmit()
      //   }
      // }, 2500);
    })
  }

  handleNormalFields = (event) => {
    var keyName = event.target.name;
    var keyVal = event.target.value;
    this.setState({
      [event.target.name]: event.target.value,
      isAnyValueChange: true
    }, () => {
      //dont upadte lead if first name is empty
      // if(this.state.fieldsObj['name'] && this.state.fieldsObj['name'].opportunitiesvalue == ""){
      //   return false
      // }
      // setTimeout(() => {
      //   if (this.state[keyName] == keyVal) {
      //     this.handleFormSubmit()
      //   }
      // }, 1500);
    })
  };

  handleCountryChange = (event, values) => {
    this.setState({
      country: values,
      isAnyValueChange: true
    }, () => {
      //dont upadte lead if first name is empty
      if (this.state.fieldsObj['name'] && this.state.fieldsObj['name'].opportunitiesvalue == "") {
        return false
      }
      setTimeout(() => {
        if (this.state.country == values) {
          this.handleFormSubmit()
        }
      }, 500);
    })
  }

  focusInValue = () => {
    this.setState({
      focusValue: true,
    }, () => this.forceUpdate())
  };


  currencyDropdownClose = () => {
    this.setState({ focusValue: false })
  };

  handleCompanyChange = (val, newValue) => {
    let id = (newValue.__isNew__) ? "0" : newValue.value;
    let comp_values = { srno: "1", id: id, value: newValue.label };
    this.handleChange({ fieldid: "44", values: [comp_values] }, 'company', 'allowSubmitChange');
    this.setState({ comp_value: id });
  };

  handlePrimaryContactChange = (val, newValue) => {
    let id = (newValue.__isNew__) ? "0" : newValue.value;
    let contact_values = { srno: "1", id: id, value: newValue.label };
    this.handleChange({ fieldid: "42", values: [contact_values] }, 'primarycontact', 'allowSubmitChange');
    this.setState({ primarycontact_value: id });
  };

  handleChange = (val, name, isSubmit) => {
    if (val.fieldid === "54") {
      this.setState({ isEditVisibility: true }, () => this.forceUpdate())
      if (val.values.id === 2) {
        this.setState({ selectedTeamList: [{}] }, () => this.forceUpdate())
      } else if (val.values.id === 3) {
        this.setState({ selectedUserList: [{}] }, () => this.forceUpdate())
      }
    }
    var winVal = "";

    if (val.fieldid == "45" && (val.values.name == "Abandoned" || val.values.name == "Lost" || val.values.name == "Won")) {
      this.handleMouseUpStaticLane(val.values.name.toLowerCase())
      isSubmit = false;
    } else if (val.fieldid === "41") {//pipeline dorpdown change
      this.setState({
        stageArray: val.values.stage,
        pipeline_id_createpopup: val.values.id,
      }, () => {
        this.forceUpdate()
        this.getUserPermission()
        this.setState({
          fieldsObj: {
            ...this.state.fieldsObj,
            ["stage"]: { fieldid: "47", values: val.values.stage[0] },
            ["winpercentage"]: { fieldid: "52", opportunitiesvalue: val.values.stage[0].probability },
          },
          updatedfieldid: parseFloat(val.fieldid)
        })
      })
    } else if (val.fieldid === "47") {//stage dorpdown change
      winVal = { fieldid: "52", opportunitiesvalue: val.values.probability }
    }
    var key = this.findWithAttr(this.state.fieldsList, 'id', val.fieldid);
    if (key != -1 && this.state.fieldsList[key].fieldtype.id != "4" && this.state.fieldsList[key].fieldtype.id != "8") {
      if (this[name]) {
        this[name].validate(val.value);
      }
    }
    if (val.fieldid === "46") {
      if ((this.state.viewoption === 2 || this.state.viewoption === 3) && val.values === null) {
        this.setState({
          teamVisibilityLabel: "0 users",
          teamUser: []
        }, () => this.forceUpdate())
      } else {
        this.setState({
          fieldsObj: {
            ...this.state.fieldsObj,
            [name]: val,
          }
        }, () => this.getUserPermission())
      }
    }

    this.setState({
      fieldsObj: {
        ...this.state.fieldsObj,
        [name]: val,
        ['winpercentage']: winVal ? winVal : (val.fieldid == "52") ? val : this.state.fieldsObj['winpercentage']
      },
      isAnyValueChange: true,
      updatedfieldid: parseFloat(val.fieldid)
    }, () => {

      if (!isSubmit) {
        return false
      }
      setTimeout(() => {
        if (this.state.fieldsObj[name] == val) {
          console.log("this.state.fieldsObj", this.state.fieldsObj);
          this.handleFormSubmit()
        }
      }, 500);
    })
  };

  focusOutSubmitForm = (event, fieldId, ref) => {
    this.setState({ updatedfieldid: parseFloat(fieldId) })

    console.log("this[ref]", this[ref]);
    if (this[ref].props && this[ref].props.id == "tagInputId1") {
      setTimeout(() => {
        document.getElementById("tagInputId1").value = "";
      }, 10)
    }
    this[ref].validate(event.target.value);
    setTimeout(() => {
      if (this.state.isAnyValueChange) {
        this.handleFormSubmit()
      }
    }, 0);
  }

  handleFormSubmit = () => {
    this.updateLeadForm.isFormValid(false).then(isValid => {
      this.setState({
        isAnyValueChange: false
      }, () => this.forceUpdate())

      if (isValid) {
        let logData = [];
        let submitData = JSON.parse(JSON.stringify(this.state.fieldsObj));
        console.log("this.state.fieldsObj", this.state.fieldsObj);
        submitData = Object.values(submitData).map((row) => {
          if (row.fieldid == "50") {
            row.values = [{ id: this.state.companyCurrencyData.currencyid.toString(), srno: "1", value: row.opportunitiesvalue }]
            delete row['opportunitiesvalue'];
            if (row.values[0].value == "") {
              row.values = []
            }
          }


          if (row.fieldid === "54" || row.fieldid === "48" || row.fieldid === "45" || row.fieldid === "51" || row.fieldid === "41" || row.fieldid === "47") {//54-visibility,48-source,45-status,51-Priority
            if (row.fieldid === "54") {
              let filterVisibleList = [];
              if (row.values.id === 2) {
                filterVisibleList = this.state.selectedTeamList.length > 0 ? this.state.selectedTeamList.filter(el => Object.keys(el).length) : []
              } else if (row.values.id === 3) {
                filterVisibleList = this.state.selectedUserList.length > 0 ? this.state.selectedUserList.filter(el => Object.keys(el).length) : []
              }
              row.values = [
                {
                  srno: "1",
                  id: row.values.id,
                  value: row.values.name,
                  visiblelist: filterVisibleList
                }
              ];
            } else {
              row.values = [{ srno: "1", id: row.values.id, value: row.values.name }]
            }
          }
          var key = this.findWithAttr(this.state.fieldsList, 'id', row.fieldid);
          if (this.state.fieldsList[key].fieldtype.id == "4" && this.state.fieldsList[key].is_default == false) {
            row.values = [{ srno: "1", id: row.values.id, value: row.values.optionvalue }]
          }
          if (this.state.fieldsList[key].fieldtype.id == "54" && this.state.fieldsList[key].is_default == false) {
            var ar = [];
            if (row.values.length > 0) {
              row.values.map((val, i) => {
                var optName;
                if (val.optionvalue) {
                  optName = val.optionvalue
                } else {
                  optName = val.value
                }
                ar.push({ srno: (i + 1).toString(), id: val.id, value: optName })
              })
            }
            row.values = ar
          }

          //validating date fiels
          if (this.state.fieldsList[key].fieldtype.id == "8") {//date field
            if (row.values == null) {
              row.opportunitiesvalue = "";
              delete row.values;
            } else if (row.values == "Invalid Date") {
              return false
            } else {
              // row.opportunitiesvalue = moment(row.values).format("X");

              // let date_test = moment(row.values).format('YYYY-MM-DD HH:mm');
              // var logdate = moment.tz(date_test, this.state.userSettings.timezone).format();
              // row.opportunitiesvalue = moment.utc(logdate).format('X');
              var dt = moment(row.values).format('YYYY-MM-DD')
              row.opportunitiesvalue = dt;

              delete row.values;
            }
          }

          if (row.fieldid == "56") {
            if (row.values.length > 0) {
              var objArr = [];
              row.values.map((val, k) => {
                var foundKey = this.findWithAttr(this.state.systemTagsList, 'tagname', val);
                var tagId = "0";
                if (foundKey !== -1) {
                  tagId = this.state.systemTagsList[foundKey].id
                }
                objArr.push({ "srno": (k + 1).toString(), value: val.toLowerCase(), id: tagId, isdeleted: "0" })
              })

              //add tags from props value which is removed   with id deleted id "1"
              var tagsKeyFromProps = this.findWithAttr(this.props.opportunityReducer.opportunityFieldData.data, 'id', "56");
              if (this.props.opportunityReducer.opportunityFieldData.data[tagsKeyFromProps].opportunitiesdetail.length > 0) {
                var oldTagsValues = this.props.opportunityReducer.opportunityFieldData.data[tagsKeyFromProps].opportunitiesdetail[0].values;
                if (oldTagsValues.length > 0) {
                  oldTagsValues.map((v, k) => {
                    var checkKey = this.findWithAttr(objArr, 'value', v.value);
                    if (checkKey === -1) {
                      v.isdeleted = "1";
                      v.srno = (objArr.length + 1).toString();
                      objArr.push(v);
                    }
                  })
                }
              }

              row.values = objArr
              if (this.props.opportunityReducer.opportunityFieldData.data[tagsKeyFromProps].opportunitiesdetail.length > 0) {
                this.props.opportunityReducer.opportunityFieldData.data[tagsKeyFromProps].opportunitiesdetail[0].values = objArr;
              }
            }
          }

          if (row.fieldid == "8") {//address field
            row.opportunitiesvalue = {
              street: row.opportunitiesvalue,
              city: this.state.city,
              state: this.state.addressState,
              zipcode: this.state.zipcode,
              country: (this.state.country && this.state.country.name) ? this.state.country.name : ""
            }
          }
          if (row.fieldid == "46") {//owner value set
            if (row.values) {
              row.values = [{ "srno": "1", id: row.values.id, value: row.values.email, name: row.values.name }];
            } else {
              row.values = [];
            }
            delete row.opportunitiesvalue;
          }
          return row;
        })

        //adding  opportunitiesdetailid for update object from this.state.opportunityFieldData
        submitData = submitData.map((row, i) => {
          var key = this.findWithAttr(this.state.opportunityFieldData, 'id', row.fieldid);
          if (key !== -1) {
            if (this.state.opportunityFieldData[key].opportunitiesdetail.length > 0) {
              row.opportunitiesdetailid = this.state.opportunityFieldData[key].opportunitiesdetail[0].id;
            } else {
              row.opportunitiesdetailid = ""
            }
          }


          return row
        })

        //filter null and undefined object 
        submitData = submitData.filter(function (element) {
          return element !== undefined;
        });

        //not to submit if any field is false
        var allowToSubmit = true
        submitData.map((row) => {
          if (!row) {
            allowToSubmit = false
          }
        })
        console.log("submitData", submitData);
        //return

        if (this.state.opportunities_id && allowToSubmit) {
          // update lead field data after update.... (For log)
          this.setState({ isUpdate: true, isEditVisibility: false });
          // -- ---------------

          let req = {
            piplineid: parseFloat(this.state.selectedPipelineId),
            opportunitiesdata: submitData,
            opportunitiesid: this.state.opportunities_id,
            sidebarSubmit: true,
            updatedfieldid: this.state.updatedfieldid,
            teamvisible: this.state.teamvisible,

          }
          this.props.updateOpportunitiesDetail(this.props.apolloClient.client, req);
        }
      }
    });
  };

  arrDifference = (arr1, arr2) => {
    var arr = [];
    arr1 = arr1.toString().split(',').map(Number);
    arr2 = arr2.toString().split(',').map(Number);
    // for array1
    for (var i in arr1) {
      if (arr2.indexOf(arr1[i]) === -1)
        arr.push(arr1[i]);
    }
    // for array2
    for (i in arr2) {
      if (arr1.indexOf(arr2[i]) === -1)
        arr.push(arr2[i]);
    }
    return arr.sort((x, y) => x - y);
  }

  findWithAttr = (array, attr, value) => {
    for (var i = 0; i < array.length; i += 1) {
      if (array[i][attr] == value) {
        return i;
      }
    }
    return -1;
  }

  teamHandleChange = (index, value, name) => {
    let mianteam = this.state.teamList;
    let selectedTeamList = this.state.selectedTeamList
    let mianUsers = this.state.usersListArray;
    let selectedUserList = this.state.selectedUserList
    if (name === "team") {
      if (value !== null) {
        selectedTeamList[index] = value;
        if (mianteam.length + 1 > selectedTeamList.length) {
          selectedTeamList[index + 1] = {};
        }
      } else {
        selectedTeamList.splice(index, 1);
        if (selectedTeamList.length === 0) {
          selectedTeamList[0] = {};
        }
      }
    } else {
      if (value !== null) {
        selectedUserList[index] = { id: value.id, name: value.name }
        if (mianUsers.length + 1 > selectedUserList.length) {
          selectedUserList[index + 1] = {};
        }
      } else {
        selectedUserList.splice(index, 1);
        if (selectedUserList.length === 0) {
          selectedUserList[0] = {};
        }
      }
    }
    this.setState({
      selectedTeamList: selectedTeamList,
      selectedUserList: selectedUserList
    })
  }
  handleToggleEditVisibility = () => {
    this.setState({
      isEditVisibility: !this.state.isEditVisibility
    })
  }

  handleChangeVisibilityRadio = (value) => {
    if (value) {
      let customFields = [...this.state.fieldsList]
      var vkey = this.findWithAttr(customFields, "id", "54");
      var visibilitydefault = this.findWithAttr(
        customFields[vkey].options,
        "is_default",
        true
      );
      this.setState({
        selectedTeamList: [],
        updatedfieldid: 5,
        fieldsObj: {
          ...this.state.fieldsObj,
          ["visibility"]: {
            fieldid: "54",
            values: customFields[vkey].options[visibilitydefault],
          },
        },
      });
    }
    this.setState({
      teamvisible: value === "true" ? true : false
    })

  }
  handleVisibilitySave = () => {
    this.setState({
      updatedfieldid: 5
    }, () => this.handleFormSubmit())
  }
  hadleCancelvisibility = () => {
    let fieldsObj = this.state.fieldsObj
    let customFields = [...this.state.fieldsList]
    var vkey = this.findWithAttr(customFields, "id", "54");
    var visibilitydefault = this.findWithAttr(customFields[vkey].options, "is_default", true);

    let opportunityFieldData = [...this.state.opportunityFieldData]
    var key1 = this.findWithAttr(opportunityFieldData, 'id', "54");
    if (opportunityFieldData[key1].opportunitiesdetail[0].values[0]) { //if visibilty not efault 
      let mainoldValue = opportunityFieldData[key1].opportunitiesdetail[0].values[0];
      var opn = this.findWithAttr(opportunityFieldData[key1].options, 'id', mainoldValue.id);
      fieldsObj = {
        ...fieldsObj,
        ["visibility"]: {
          fieldid: "54",
          values: opportunityFieldData[key1].options[opn],
        },
      }
    } else {//set  visibilty  default 
      fieldsObj = {
        ...fieldsObj,
        ["visibility"]: {
          fieldid: "54",
          values: customFields[vkey].options[visibilitydefault],
        },
      }
    }
    this.setState({
      selectedTeamList: this.state.oldSelctedTeamList,
      selectedUserList: this.state.oldSlectedUserList,
      fieldsObj: fieldsObj,
      teamvisible: this.state.oldteamvisible,

    });
    this.handleToggleEditVisibility()
  }
  render() {
    // console.log("this.state.pipelineListArray", this.state.pipelineListArray);

    /*STRAT contact Display*/
    let displayContactListWon = []
    {
      this.state.opportunityContactListArray.map((item, key) => {
        let flagToPush = true
        if (item.contact.contactdetail.length > 0) {
          var contactName = ""
          var contactType = ""
          item.contact.contactdetail.map((data, key1) => {
            if (data.field.id == "16") {//name
              contactName = data.fieldvalue;
            }
            if (data.field.id == "19" && data.values.length > 0) {//contacttype
              console.log("data.values", data.values);
              contactType = data.values[0].value;
              if (data.values[0].id == "2") {//do not push if already current customer
                flagToPush = false
              }
            }
          })
          if (flagToPush) {
            displayContactListWon.push(
              <Grid item xs={12}>
                <FormControl className="input_bx">
                  <FormControlLabel
                    control={
                      <Checkbox
                        id={item.contact.id}
                        checked={this.state.contactTypeObj[key] ? this.state.contactTypeObj[key].checked : false}
                        onChange={(event, value) => this.handleChangeContactTypeCheckBox(event, key, value, 'contact')}
                        value={this.state.contactTypeObj[key] ? this.state.contactTypeObj[key].checked : false}
                        color="primary"
                      />
                    }
                    label={<div style={{ fontSize: "14px" }}>
                      <span>Turn &nbsp;</span>
                      <span style={{ fontWeight: 'bold' }}>{contactName}&nbsp;</span>
                      <span>From &nbsp;</span>
                      <span style={{ fontWeight: 'bold' }}>{contactType}&nbsp;</span>
                      <span>to &nbsp;</span>
                    </div>}
                  />
                </FormControl>
                <Select
                  id={item.contact.id}
                  style={{ top: '8px', left: '-16px' }}
                  value={this.state.contactTypeObj[key] ? this.state.contactTypeObj[key].contacttype : ""}
                  onChange={(event, value) => this.handleChangeContactTypeDropdown(event, key, value, 'contact')}
                  SelectDisplayProps={{ className: "multiple-text-dropdown" }}
                >
                  {this.state.contactTypeList.length > 0 && this.state.contactTypeList.map((item, key) =>
                    <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                  )}
                </Select>
              </Grid>
            )
          }
        }

      })
    }
    /*END contact Display*/

    /*STRAT company Display*/
    let displayCompanyListWon = []
    {
      this.state.opportunityCompanyListArray.map((item, key) => {
        let flagToPush = true
        if (item.company.companydetail.length > 0) {
          var companyName = ""
          var companyType = ""
          item.company.companydetail.map((data, key1) => {
            if (data.field.id == "29") {//name
              companyName = data.fieldvalue;
            }
            if (data.field.id == "33" && data.values.length > 0) {//contacttype
              companyType = data.values[0].value;
              if (data.values[0].id == "2") {//do not push if already current customer
                flagToPush = false
              }
            }

          })
          if (flagToPush) {
            displayCompanyListWon.push(
              <Grid item xs={12}>
                <FormControl className="input_bx">
                  <FormControlLabel
                    control={
                      <Checkbox
                        id={item.company.id}
                        checked={this.state.contactTypeObjCmp[key] ? this.state.contactTypeObjCmp[key].checked : false}
                        onChange={(event, value) => this.handleChangeContactTypeCheckBox(event, key, value, 'company')}
                        value={this.state.contactTypeObjCmp[key] ? this.state.contactTypeObjCmp[key].checked : false}
                        color="primary"
                      />
                    }
                    label={<div style={{ fontSize: "14px" }}>
                      <span>Turn company &nbsp;</span>
                      <span style={{ fontWeight: 'bold' }}>{companyName}&nbsp;</span>
                      <span>From &nbsp;</span>
                      <span style={{ fontWeight: 'bold' }}>{companyType}&nbsp;</span>
                      <span>to &nbsp;</span>
                    </div>}
                  />
                </FormControl>
                <Select
                  id={item.company.id}
                  style={{ top: '8px', left: '-16px' }}
                  value={this.state.contactTypeObjCmp[key] ? this.state.contactTypeObjCmp[key].contacttype : ""}
                  onChange={(event, value) => this.handleChangeContactTypeDropdown(event, key, value, 'company')}
                  SelectDisplayProps={{ className: "multiple-text-dropdown" }}
                >
                  {this.state.contactTypeList.length > 0 && this.state.contactTypeList.map((item, key) =>
                    <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                  )}
                </Select>
              </Grid>
            )
          }
        }

      })
    }
    /*END company Display*/
    return (
      <div className="v_scroll position-relative label-size-14 pr-16">
        <ValidatorForm ref={updateLeadForm => this.updateLeadForm = updateLeadForm} noValidate instantValidate={false} onSubmit={this.handleFormSubmit}>
          <Grid container spacing={2}>
            {CreateFieldsDynamicLeadEdit(this)}
          </Grid>
        </ValidatorForm>

        {this.state.isOpenLostPopup && (
          <Dialog onClose={this.handleLostPopupClose} open={this.state.isOpenLostPopup} maxWidth="sm" fullWidth={true} className={`crm-custom-bg-primary custom_dialog ${this.state.minimizeLostDialog && this.state.fullScreenLostDialog ? 'alignitemsend-fullscreen' : ''} ${this.state.minimizeLostDialog ? 'alignitemsend' : ''} ${this.state.fullScreenLostDialog ? 'fullscreen' : ''}`} disableBackdropClick >
            <div className="d-flex justify-content-between align-items-center pl-16 pr-4 py-4" style={{ background: '#f44336cc' }}>
              <h4 className="m-0 text-white">Lost opportunity</h4>
              <div className="d-flex">
                <TooltipNew title={this.state.minimizeLostDialog ? 'Normal Screen' : 'Minimize Screen'}>
                  <IconButton onClick={this.handleLostDialogMinimize}>
                    <Icon className="text-white">{this.state.minimizeLostDialog ? 'add' : 'remove'}</Icon>
                  </IconButton>
                </TooltipNew>
                <TooltipNew title={this.state.fullScreenLostDialog ? 'Exit Full Screen' : 'Full Screen'}>
                  <IconButton onClick={this.handleLostDialogFull}>
                    <Icon className="text-white">{this.state.fullScreenLostDialog ? 'fullscreen_exit' : 'fullscreen'}</Icon>
                  </IconButton>
                </TooltipNew>
                <TooltipNew title="Close">
                  <IconButton onClick={this.handleLostPopupClose}>
                    <Icon className="text-white">clear</Icon>
                  </IconButton>
                </TooltipNew>
              </div>
            </div>
            <ValidatorForm>
              <div className="dialog-body-no-scroll" style={{ padding: '25px' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    Add a loss reason and add any additional notes below.
                    </Grid>
                  <Grid item xs={12}>
                    <Select
                      name={"lossdropdownVal"}
                      id={"lossdropdownVal"}
                      value={this.state.lossdropdownVal}
                      onChange={this.handleChangeVals}
                      SelectDisplayProps={{ className: "multiple-text-dropdown" }}
                    >
                      <MenuItem key={0} value={0}>{"No Loss Reason Selected"}</MenuItem>
                      {this.state.loassReasonList.length > 0 && this.state.loassReasonList.map((item, key) =>
                        <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                      )}
                    </Select>
                  </Grid>
                  <Grid item xs={12}>
                    <TextValidator
                      className="w-100 input_bx"
                      placeholder="(Optional) Add additional notes here"
                      onChange={this.handleChangeVals}
                      type="text"
                      name="optionalNoteLost"
                      helperText="Lost Opportunities can be seen in the Opportunities list by selecting the status filter and selecting the 'Lost' option."
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl className="w-100 input_bx">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name={"changeDate"}
                            id={"changeDate"}
                            checked={this.state.changeDate}
                            onChange={this.handleChangeVals}
                            value={this.state.changeDate}
                            color="primary"
                          />
                        }
                        label={"Change Close Date to today?"}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </div>
              <DialogActions className="dialog-action">
                <Button variant="contained" onClick={this.handleLostPopupClose}>Cancel</Button>
                <Button variant="contained" type="submit" color="primary" onClick={this.handleSaveLossPopup}>
                  save
                  </Button>
              </DialogActions>
            </ValidatorForm>
          </Dialog>
        )}

        {this.state.isOpenWonPopup && (
          <Dialog onClose={this.handleWonPopupClose} open={this.state.isOpenWonPopup} maxWidth="sm" fullWidth={true} className={`crm-custom-bg-primary custom_dialog ${this.state.minimizeWonDialog && this.state.fullScreenWonDialog ? 'alignitemsend-fullscreen' : ''} ${this.state.minimizeWonDialog ? 'alignitemsend' : ''} ${this.state.fullScreenWonDialog ? 'fullscreen' : ''}`} disableBackdropClick >
            <div className="d-flex justify-content-between align-items-center pl-16 pr-4 py-4" style={{ background: '#08ad6ccc' }}>
              <h4 className="m-0 text-white">Won opportunity</h4>
              <div className="d-flex">
                <TooltipNew title={this.state.minimizeWonDialog ? 'Normal Screen' : 'Minimize Screen'}>
                  <IconButton onClick={this.handleWonDialogMinimize}>
                    <Icon className="text-white">{this.state.minimizeWonDialog ? 'add' : 'remove'}</Icon>
                  </IconButton>
                </TooltipNew>
                <TooltipNew title={this.state.fullScreenWonDialog ? 'Exit Full Screen' : 'Full Screen'}>
                  <IconButton onClick={this.handleWonDialogFull}>
                    <Icon className="text-white">{this.state.fullScreenWonDialog ? 'fullscreen_exit' : 'fullscreen'}</Icon>
                  </IconButton>
                </TooltipNew>
                <TooltipNew title="Close">
                  <IconButton onClick={this.handleWonPopupClose}>
                    <Icon className="text-white">clear</Icon>
                  </IconButton>
                </TooltipNew>
              </div>
            </div>
            <ValidatorForm noValidate debounceTime={500}>
              <div className="dialog-body-no-scroll" style={{ padding: '25px' }}>
                <Grid container spacing={2}>
                  {(displayContactListWon.length > 0 || displayCompanyListWon.length > 0) &&
                    (<>
                      <Grid item xs={12}>
                        Would you like to update your records to reflect a new Contact Type?
                                </Grid>
                      <Grid item xs={12}>
                        {displayContactListWon}
                        {displayCompanyListWon}
                      </Grid>
                    </>)
                  }

                  <Grid item xs={12}>
                    Would you like to add final notes before this opportunity is archived?
                    </Grid>
                  <Grid item xs={12}>
                    <TextValidator
                      className="w-100 input_bx"
                      placeholder="(Optional) Add additional notes here"
                      onChange={this.handleChangeVals}
                      type="text"
                      name="optionalNoteWon"
                      helperText="Won opportunities can be seen in the opportunities list by selecting the status filter and selecting the 'Won' option."
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl className="w-100 input_bx">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name={"changeDate"}
                            id={"changeDate"}
                            checked={this.state.changeDate}
                            onChange={this.handleChangeVals}
                            value={this.state.changeDate}
                            color="primary"
                          />
                        }
                        label={"Change Close Date to today?"}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </div>
              <DialogActions className="dialog-action">
                <Button variant="contained" onClick={this.handleWonPopupClose}>Cancel</Button>
                <Button variant="contained" onClick={this.handleSaveWonPopup} type="submit" color="primary">
                  save
                  </Button>
              </DialogActions>
            </ValidatorForm>
          </Dialog>
        )}

        {this.state.isOpenAbandonedPopup && (
          <Dialog onClose={this.handleAbandonedPopupClose} open={this.state.isOpenAbandonedPopup} maxWidth="sm" fullWidth={true} className={`crm-custom-bg-primary custom_dialog ${this.state.minimizeAbandonedDialog && this.state.fullScreenAbandonedDialog ? 'alignitemsend-fullscreen' : ''} ${this.state.minimizeAbandonedDialog ? 'alignitemsend' : ''} ${this.state.fullScreenAbandonedDialog ? 'fullscreen' : ''}`} disableBackdropClick >
            <div className="d-flex justify-content-between align-items-center pl-16 pr-4 py-4" style={{ background: '#ffffffcc' }}>
              <h4 className="m-0 ">Abandoned opportunity</h4>
              <div className="d-flex">
                <TooltipNew title={this.state.minimizeAbandonedDialog ? 'Normal Screen' : 'Minimize Screen'}>
                  <IconButton onClick={this.handleAbandonedDialogMinimize}>
                    <Icon className="">{this.state.minimizeAbandonedDialog ? 'add' : 'remove'}</Icon>
                  </IconButton>
                </TooltipNew>
                <TooltipNew title={this.state.fullScreenAbandonedDialog ? 'Exit Full Screen' : 'Full Screen'}>
                  <IconButton onClick={this.handleAbandonedDialogFull}>
                    <Icon className="">{this.state.fullScreenAbandonedDialog ? 'fullscreen_exit' : 'fullscreen'}</Icon>
                  </IconButton>
                </TooltipNew>
                <TooltipNew title="Close">
                  <IconButton onClick={this.handleAbandonedPopupClose}>
                    <Icon className="">clear</Icon>
                  </IconButton>
                </TooltipNew>
              </div>
            </div>
            <ValidatorForm noValidate debounceTime={500}>
              <div className="dialog-body-no-scroll" style={{ padding: '25px' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    Would you like to add final notes before this opportunity is archived?
                    </Grid>
                  <Grid item xs={12}>
                    <TextValidator
                      className="w-100 input_bx"
                      placeholder="(Optional) Add additional notes here"
                      onChange={this.handleChangeVals}
                      type="text"
                      name="optionalNoteAbandoned"
                      helperText="Won opportunities can be seen in the opportunities list by selecting the status filter and selecting the 'Won' option."
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl className="w-100 input_bx">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name={"changeDate"}
                            id={"changeDate"}
                            checked={this.state.changeDate}
                            onChange={this.handleChangeVals}
                            value={this.state.changeDate}
                            color="primary"
                          />
                        }
                        label={"Change Close Date to today?"}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </div>
              <DialogActions className="dialog-action">
                <Button variant="contained" onClick={this.handleAbandonedPopupClose}>Cancel</Button>
                <Button variant="contained" onClick={this.handleSaveAbandonedPopup} type="submit" color="primary">
                  save
                  </Button>
              </DialogActions>
            </ValidatorForm>
          </Dialog>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settingReducer: state.settingReducer,
  apolloClient: state.apolloClient,
  notification: state.notification,
  contactReducer: state.contactReducer,
  opportunityReducer: state.opportunityReducer,
  leadReducer: state.leadReducer,
  authReducer: state.authReducer

});

const mapDispatchToProps = dispatch => {
  return {
    getTeam: (client) => dispatch(actionCreators.getTeam(client)),

    getOpportunitiesLogListNew: (client, opportunitiesid) => dispatch(actionCreators.getOpportunitiesLogListNew(client, opportunitiesid)),
    customFieldList: (client, request) => { dispatch(actionCreators.customFieldList(client, request)) },
    updateOpportunitiesDetail: (client, request) => { dispatch(actionCreators.updateOpportunitiesDetail(client, request)) },
    getCountryList: (client) => { dispatch(actionCreators.getCountryList(client)) },
    clearNotification: () => dispatch(actionCreators.clearNotification()),
    getCompanyCurrency: (client) => dispatch(actionCreators.getCompanyCurrency(client)),
    getTagsList: (client) => dispatch(actionCreators.getTagsList(client)),
    getOpportunitiesField: (client, opportunitiesid) => dispatch(actionCreators.getOpportunitiesField(client, opportunitiesid)),
    getUserList: (client) => dispatch(actionCreators.getUserList(client)),
    getUserSetting: (client, data) => dispatch(actionCreators.getUserSetting(client, data)),
    getCompanyRecList: (client) => { dispatch(actionCreators.getCompanyRecList(client)) },
    getContactRecList: (client) => { dispatch(actionCreators.getContactRecList(client)) },

    getPipelines: (client) => dispatch(actionCreators.getPipelines(client)),
    getOpportunitiesFilterList: (client, request) => { dispatch(actionCreators.getOpportunitiesFilterList(client, request)) },
    getOpportunitiesContactList: (client, opportunities_id) => { dispatch(actionCreators.getOpportunitiesContactList(client, opportunities_id)) },
    getOpportunitiesCompanyList: (client, opportunities_id) => { dispatch(actionCreators.getOpportunitiesCompanyList(client, opportunities_id)) },
    opportunitiesWin: (client, req) => { dispatch(actionCreators.opportunitiesWin(client, req)) },
    opportunitiesLost: (client, req) => { dispatch(actionCreators.opportunitiesLost(client, req)) },
    getLossReasonList: (client) => dispatch(actionCreators.getLossReasonList(client)),
    getContactType: (client, req) => { dispatch(actionCreators.getContactType(client, req)) },
  }
}

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(ProfileDetails);
export default (connect(mapStateToProps, mapDispatchToProps)(withRouter(ProfileDetails)));